import { StreamingService } from 'src/app/services/streaming.service';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { PopupBidsComponent } from '../modals/popup-bids/popup-bids.component';
import { StorageService } from './../../services/storage.service';
import { IUser } from 'src/app/models/user';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ConfigService } from 'src/app/services/config.service';
import { PopupLoginComponent } from '../modals/popup-login/popup-login.component';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, OnDestroy {
  @Input() colapse: 'vertical' | 'horizontal' = 'vertical';
  @ViewChild('navbar') navbar: ElementRef<HTMLElement> | undefined;

  constructor(
    private storage: StorageService,
    private router: Router,
    private dialog: MatDialog,
    private authService: AuthService,
    private snackbarService: SnackbarService,
    private configService: ConfigService,
    private streaming: StreamingService
  ) {
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd || ev instanceof NavigationStart) {
        this.url = ev.url.split('/')[1];
      }
    });
  }

  url: string | undefined;

  loading = 0;
  user: IUser = {} as IUser;

  navbar_hidden = true;
  scroll = false;
  navbar_height = 0;

  auctions: any = [];
  socket = new WebSocket('wss://socket.wvleiloes.com/');
  isStatus = '';

  events_socket = ['Atualizar', 'CLOSED', 'OPEN']

  ngOnInit(): void {
    this.onWindowScroll();

    this.getMe();
    this.storage.watchUser().subscribe({
      next: () => {
        this.getMe();
      },
    });
    this.getConfig();

    this.connectSocket();
  }

  getMe() {
    this.user = this.storage.myself;

    if (this.storage.token) {
      this.loading += 1;
      this.authService.getMe().subscribe({
        next: (data) => {
          this.user = data;
          this.storage.myself = data;
          this.getOpenTransactions();
          this.loading -= 1;

          // if(localStorage.getItem('__DEV__')) this.openPopupBids()
        },
        error: (error) => {
          this.loading -= 1;
          if (error?.status === 401) {
            this.storage.logout();
          }
        },
      });
    }
    else{
      this.getOpenTransactions();
    }
  }

  getConfig() {
    if (this.url === '') {
      this.loading += 1;
      this.configService.getConfig().subscribe({
        next: (data) => {
          if (data.open_in_transmission && data.schedule_event) {
            this.router.navigate(['/streaming'], {
              queryParams: {
                schedule_event: data.schedule_event,
              },
            });
          }
          this.loading -= 1;
        },
        error: (error) => {
          this.loading -= 1;
          if (error?.status === 401) {
            this.storage.logout();
          }
        },
      });
    }
  }

  connectSocket() {
    this.socket.addEventListener('open', function (event) {
      console.log('-----[ WebSocket connection ]-----');
    });

    this.socket.addEventListener('message', (event: MessageEvent) => {
      const message = event.data;
      if ( this.events_socket.includes(message)) {
        this.getOpenTransactions();
      }
    });

    // Adicionar evento de erro do WebSocket
    this.socket.addEventListener("error", function (error) {
      console.error("Erro no WebSocket:", error);
    });

    // Adicionar evento de fechamento do WebSocket
    this.socket.addEventListener("close", function (event) {
      console.log("WebSocket fechado:", event);
    });
  }

  ngOnDestroy(): void {
    this.storage.unwatchUser();
  }

  getOpenTransactions() {
    this.streaming.openedScheldule().subscribe({
      next: (data) => {
        this.auctions = data.filter((el: any) => el.enable_site_virtual);

        this.auctions.forEach((element: any) => {
          this.isStatus = ''

          if(this.user.id && element.transaction?.auction_bid?.user === this.user.id){
            this.isStatus = 'ACEITO'
          }

          if(this.user.id && element.transaction?.last_auction_bid?.user === this.user.id){  // #4 - n~ão achava o user
            this.isStatus = 'SUPERADO'
          }

          if(this.user.id && element.transaction?.waiting_bids?.length > 0) {

            const lance = element.transaction?.waiting_bids?.filter((el: any) => this.user.id === el.user)
            if(lance.length > 0){
              this.isStatus = lance[0].status
            }
          }
        });

        this.streaming.auctions = this.auctions;
        this.streaming.changeSocket(this.auctions)
      },
      error: (error) => {
        this.snackbarService.error(error?.error?.detail);
      },
    });
  }

  logout() {
    this.navbar_hidden = true;
    this.user = {} as IUser;
    this.storage.myself = {} as IUser;
    this.storage.logout();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const scroll = window.scrollY;

    this.scroll = scroll > window.screen.height / 3;

    setTimeout(() => {
      if (this.navbar) {
        this.navbar_height = this.navbar.nativeElement.offsetHeight;
      }
    }, 300);
  }

  openPopupBids() {
    if (!this.user?.id) {
      this.openPopuplogIn();
      return;
    }

    this.dialog.open(PopupBidsComponent, {
      width: '90%',
      maxWidth: '500px',
      panelClass: 'streaming',
    });
  }

  openPopuplogIn() {
    const popupLoginRef = this.dialog.open(PopupLoginComponent, {
      width: '90%',
      maxWidth: '400px',
    });
    popupLoginRef.afterClosed().subscribe((result: any) => {
      if (result.action === 'yes') {
        window.location.reload();
      }
    });
  }
}
